import { Observable, empty, of } from 'rxjs';
import { Injectable, EventEmitter } from '@angular/core';
import { IEditableInline } from 'src/app/api/ieditable-inline';
import { InlineEditService } from 'src/app/services/inline-edit.service';
import { PerformanceBodDataService } from 'src/app/services/performance-bod-data.service';
import { PerformanceBodStoreService } from 'src/app/services/performance-bod-store.service';
import { map } from 'rxjs';
import { IPerformanceBodRoadMaintenance } from 'src/app/api/performance-bod-road-maintenance';

@Injectable({
  providedIn: 'root',
})
export class InfrastructureRoadMaintenanceService extends InlineEditService implements IEditableInline {
  public data: IPerformanceBodRoadMaintenance[] = [];
  public originalData: IPerformanceBodRoadMaintenance[] = [];
  public createdItems: IPerformanceBodRoadMaintenance[] = [];
  public updatedItems: IPerformanceBodRoadMaintenance[] = [];
  public deletedItems: IPerformanceBodRoadMaintenance[] = [];

  public performanceBodId: string;
  public completed: EventEmitter<boolean>;

  constructor(
    private performanceBodDataService: PerformanceBodDataService,
    private performanceBodStoreService: PerformanceBodStoreService
  ) {
    super();
    this.performanceBodStoreService.performanceBodId$.subscribe(id => {
      this.performanceBodId = id;
    });
  }

  public isNew(item: any): boolean {
    return !item.id;
  }

  public itemIndex(item: any, data: IPerformanceBodRoadMaintenance[]): number {
    for (let idx = 0; idx < data.length; idx++) {
      if (data[idx].id === item.id) {
        return idx;
      }
    }
    return -1;
  }

  public create(): Observable<any> {
    return this.performanceBodDataService.createPerformanceBodRoadMaintenance(this.createdItems);
  }

  public retrieve(): Observable<any> {
    return this.performanceBodDataService.getPerformanceBodRoadMaintenance(this.performanceBodId).pipe(
      map(roadMaintenance => {
        return roadMaintenance;
      })
    );
  }

  public update(): Observable<any> {
    return this.performanceBodDataService.updatePerformanceBodRoadMaintenance(this.updatedItems);
  }

  public delete(): Observable<any> {
    return this.performanceBodDataService.updatePerformanceBodRoadMaintenance(this.deletedItems);
  }
}
